export const desktopMenu = () => {
  const closeCurrentFoldout = () => (document.activeElement as HTMLElement)?.blur();

  const closeOnEscapeHandler = (e: KeyboardEvent) => {
    // TODO POST-LAUNCH toggle aria-expanded on open/close
    if (e.key === "Escape") {
      e.stopPropagation();

      closeCurrentFoldout();
    }
  };

  // Prevent navigation when clicking on a menu item which should open a submenu
  document
    .querySelectorAll("[data-js-menu-prevent-navigation]")
    .forEach(link => link.addEventListener("click", e => e.preventDefault()));

  document
    .querySelectorAll("[data-js-menu=close-on-esc]")
    .forEach(panel =>
      panel.addEventListener("keydown", e => closeOnEscapeHandler(e as KeyboardEvent))
    );

  document
    .querySelectorAll("[data-js-menu=overlay]")
    .forEach(overlay => overlay.addEventListener("click", closeCurrentFoldout));
};
